<template>
    <div class="language-selector">
      <!-- 当前语言显示 (移动端和桌面端) -->
      <div 
        class="current-language" 
        @click="toggleDropdown"
        :class="{ 'dropdown-open': showDropdown }"
      >
        <!-- <span class="language-flag" :class="currentLanguage.flag"></span> -->
         <i  class="language-flag fas fa-globe"></i>
        <span class="language-name">{{ currentLanguage.name }}</span>
        <span class="dropdown-arrow">
          <!-- <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
            <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg> -->
        </span>
      </div>
      
      <!-- 语言下拉菜单 -->
      <transition name="fade">
        <div v-show="showDropdown" class="language-dropdown">
          <div 
            v-for="lang in availableLanguages" 
            :key="lang.code"
            class="language-option"
            :class="{ 'active': lang.code === currentLanguage.code }"
            @click="selectLanguage(lang)"
          >
            <!-- <span class="language-flag" :class="lang.flag"></span> -->
            <span class="language-name">{{ lang.name }}</span>
            <span v-if="lang.code === currentLanguage.code" class="checkmark">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M13.3334 4L6.00008 11.3333L2.66675 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </span>
          </div>
          
          <!-- 语言设置链接 -->
          <!-- <div class="language-settings" @click="openLanguageSettings">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" stroke="currentColor" stroke-width="1.5"/>
              <path d="M12.7402 6.57992C12.9002 6.84659 13.0469 7.12659 13.1735 7.41326C13.2735 7.63992 13.2735 7.90659 13.1735 8.13326C13.0469 8.41992 12.9002 8.69992 12.7402 8.96659C12.4602 9.43326 12.1202 9.85992 11.7202 10.2333L10.0869 11.8666C9.56688 12.3866 8.78021 12.3866 8.26021 11.8666L6.62688 10.2333C6.22688 9.85992 5.88688 9.43326 5.60688 8.96659C5.44688 8.69992 5.30021 8.41992 5.17355 8.13326C5.07355 7.90659 5.07355 7.63992 5.17355 7.41326C5.30021 7.12659 5.44688 6.84659 5.60688 6.57992C5.88688 6.11326 6.22688 5.68659 6.62688 5.31326L8.26021 3.67992C8.78021 3.15992 9.56688 3.15992 10.0869 3.67992L11.7202 5.31326C12.1202 5.68659 12.4602 6.11326 12.7402 6.57992Z" stroke="currentColor" stroke-width="1.5"/>
            </svg>
            <span>{{ $t('languageSettings') }}</span>
          </div> -->
        </div>
      </transition>
      
      <!-- 点击外部区域关闭下拉菜单 -->
      <div v-if="showDropdown" class="dropdown-backdrop" @click="closeDropdown"></div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LangSelector',
    props: {
      // 支持的语言列表
      languages: {
        type: Array,
        default: () => [
          { code: 'zh', name: '简体中文', flag: 'flag-cn' },
          { code: 'en', name: 'English', flag: 'flag-us' },
          { code: 'ja', name: '日本語', flag: 'flag-jp' },
          { code: 'ko', name: '한국어', flag: 'flag-kr' },
          { code: 'fr', name: 'Français', flag: 'flag-fr' },
          { code: 'es', name: 'Español', flag: 'flag-es' },
          { code: 'de', name: 'Deutsch', flag: 'flag-de' },
          { code: 'ru', name: 'Русский', flag: 'flag-ru' }
        ]
      },
      // 是否保存用户选择到本地存储
      saveToStorage: {
        type: Boolean,
        default: true
      },
      // 本地存储的键名
      storageKey: {
        type: String,
        default: 'portal-language'
      }
    },
    data() {
      return {
        showDropdown: false,
        selectedLanguage: null
      };
    },
    computed: {
      // 当前选中的语言
      currentLanguage() {
        if (this.selectedLanguage) {
          return this.selectedLanguage;
        }
        
        // 尝试从本地存储获取
        if (this.saveToStorage) {
          const savedLangCode = localStorage.getItem(this.storageKey);
          if (savedLangCode) {
            const lang = this.languages.find(l => l.code === savedLangCode);
            if (lang) return lang;
          }
        }
        
        // 尝试从浏览器语言获取
        const browserLang = navigator.language.split('-')[0];
        const matchedLang = this.languages.find(l => l.code === browserLang);
        
        // 默认返回第一个语言
        return matchedLang || this.languages[0];
      },
      // 可用的语言列表（排除当前选中的）
      availableLanguages() {
        return this.languages.filter(lang => lang.code !== this.currentLanguage.code);
      }
    },
    mounted() {
      // 初始化语言
      this.initializeLanguage();
    },
    methods: {
      // 初始化语言设置
      initializeLanguage() {
        // 设置Vue i18n语言（如果使用Vue I18n）
        if (this.$i18n) {
          this.$i18n.locale = this.currentLanguage.code;
        }
        
        // 设置HTML lang属性
        document.documentElement.lang = this.currentLanguage.code;
        
        // 触发语言变更事件
        this.$emit('language-change', this.currentLanguage);
      },
      
      // 切换下拉菜单显示状态
      toggleDropdown() {
        this.showDropdown = !this.showDropdown;
      },
      
      // 关闭下拉菜单
      closeDropdown() {
        this.showDropdown = false;
      },
      
      // 选择语言
      selectLanguage(language) {
        this.selectedLanguage = language;
        this.showDropdown = false;
        
        // 保存到本地存储
        if (this.saveToStorage) {
          localStorage.setItem(this.storageKey, language.code);
        }
        
        // 更新Vue i18n语言（如果使用Vue I18n）
        if (this.$i18n) {
          this.$i18n.locale = language.code;
        }
        
        // 更新HTML lang属性
        document.documentElement.lang = language.code;
        
        // 触发语言变更事件
        this.$emit('language-change', language);
        
        // 如果是门户网站，可以在此处重新加载翻译内容
        // 或发送API请求获取新的语言内容
        this.reloadContentForLanguage(language.code);
      },
      
      // 打开语言设置页面（如果有）
      openLanguageSettings() {
        this.$emit('open-settings');
        this.showDropdown = false;
      },
      
      // 重新加载内容（示例方法，根据实际情况实现）
      reloadContentForLanguage(langCode) {
        console.log(`重新加载 ${langCode} 语言的内容`);
        // 这里可以添加API调用，获取对应语言的内容
        // 或触发父组件的重新加载方法
      }
    }
  };
  </script>
  
  <style lang='scss' scoped>
  .language-selector {
    position: relative;
    display: inline-block;
    font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
  }
  
  .current-language {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-radius: 6px;
    background-color: transparent;
    border: 1px solid transparent;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #495057;
    font-size: 0.8rem;
    font-weight: 500;
    user-select: none;
    //min-width: 100px;
  }
  
  // .current-language:hover {
  //   background-color: #e9ecef;
  //   border-color: #dee2e6;
  // }
  
  // .current-language.dropdown-open {
  //   background-color: #e9ecef;
  //   border-color: #dee2e6;
  //   border-bottom-left-radius: 6px 6px;
  //   border-bottom-right-radius: 6px 6px;
  // }
  
  .language-flag {
    display: inline-block;
    font-size:16px;
    color:var(--secondary);
    // width: 20px;
    // height: 15px;
     margin-right: 8px;
    // border-radius: 2px;
    // background-size: cover;
    // background-position: center;
    // box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
  
  .flag-cn { background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIGZpbGw9IiNERDIzMjMiLz48Y2lyY2xlIGN4PSIxMCIgY3k9IjcuNSIgcj0iMyIgZmlsbD0iI0ZGRiIvPjxwYXRoIGQ9Ik03LjUgNy41TDEwIDUuNUwxMi41IDcuNUwxMCA5LjVaIiBmaWxsPSIiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLXdpZHRoPSIwLjUiLz48L3N2Zz4='); }
  .flag-us { background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIGZpbGw9IiMjM0E1OUIiLz48cGF0aCBkPSJNMCAwSDIwVjEuNUgwVjBaIiBmaWxsPSIjRkZGIi8+PHBhdGggZD0iTTAgM0gyMFY0LjVIMFYzWiIgZmlsbD0iI0ZGRiIvPjxwYXRoIGQ9Ik0wIDZIMjBWNy41SDBWNloiIGZpbGw9IiNGRkYiLz48cGF0aCBkPSJNMCA5SDIwVjEwLjVIMFY5WiIgZmlsbD0iI0ZGRiIvPjxwYXRoIGQ9Ik0wIDEySDIwVjEzLjVIMFYxMloiIGZpbGw9IiNGRkYiLz48cmVjdCB3aWR0aD0iOC41IiBoZWlnaHQ9IjguNSIgZmlsbD0iI0M3MkIyRCIvPjwvc3ZnPg=='); }
  .flag-jp { background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIGZpbGw9IiNGRkYiLz48Y2lyY2xlIGN4PSIxMCIgY3k9IjcuNSIgcj0iMyIgZmlsbD0iI0JDMjMzNiIvPjwvc3ZnPg=='); }
  .flag-kr { background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIGZpbGw9IiNGRkYiLz48Y2lyY2xlIGN4PSIxMCIgY3k9IjcuNSIgcj0iNC41IiBmaWxsPSIjMDA0NEE5Ii8+PHBhdGggZD0iTTEwIDNMNy41IDcuNUwxMCAxMkwxMi41IDcuNVoiIGZpbGw9IiNDNzJCMkQiLz48L3N2Zz4='); }
  .flag-fr { background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB4PSIwIiB3aWR0aD0iNi42NyIgaGVpZ2h0PSIxNSIgZmlsbD0iIzAwMjY1MyIvPjxyZWN0IHg9IjYuNjciIHdpZHRoPSI2LjY2IiBoZWlnaHQ9IjE1IiBmaWxsPSIjRkZGIi8+PHJlY3QgeD0iMTMuMzMiIHdpZHRoPSI2LjY3IiBoZWlnaHQ9IjE1IiBmaWxsPSIjRUIyQzM2Ii8+PC9zdmc+'); }
  .flag-es { background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iNSIgZmlsbD0iI0M3MkIyRCIvPjxyZWN0IHk9IjUiIHdpZHRoPSIyMCIgaGVpZ2h0PSI1IiBmaWxsPSIiLz48cmVjdCB5PSIxMCIgd2lkdGg9IjIwIiBoZWlnaHQ9IjUiIGZpbGw9IiNDNzJCMkQiLz48L3N2Zz4='); }
  .flag-de { background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iNSIgZmlsbD0iIzAwMDAwMCIvPjxyZWN0IHk9IjUiIHdpZHRoPSIyMCIgaGVpZ2h0PSI1IiBmaWxsPSIjREQwMDAwIi8+PHJlY3QgeT0iMTAiIHdpZHRoPSIyMCIgaGVpZ2h0PSI1IiBmaWxsPSIjRkZDNzAwIi8+PC9zdmc+'); }
  .flag-ru { background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iNSIgZmlsbD0iI0ZGRiIvPjxyZWN0IHk9IjUiIHdpZHRoPSIyMCIgaGVpZ2h0PSI1IiBmaWxsPSIjMDAzOUEwIi8+PHJlY3QgeT0iMTAiIHdpZHRoPSIyMCIgaGVpZ2h0PSI1IiBmaWxsPSIjRUIyQzM2Ii8+PC9zdmc+'); }
  
  .dropdown-arrow {
    margin-left: auto;
    margin-right: 0;
    display: flex;
    align-items: center;
    transition: transform 0.2s ease;
  }
  
  .current-language.dropdown-open .dropdown-arrow {
    transform: rotate(180deg);
  }
  
  .language-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: white;
    border: 1px solid #e9ecef;
    border-top: none;
    border-radius: 0 0 6px 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    margin-top: -1px;
    overflow: hidden;
  }
  
  .language-option {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    color: #495057;
    font-size: 0.9rem;
    position: relative;
  }
  
  .language-option:hover {
    background-color: #f8f9fa;
  }
  
  .language-option.active {
    background-color: #f1f3f5;
    color: #228be6;
    font-weight: 500;
  }
  
  .checkmark {
    margin-left: auto;
    display: flex;
    align-items: center;
    color: #228be6;
  }
  
  .language-settings {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    cursor: pointer;
    border-top: 1px solid #e9ecef;
    background-color: #f8f9fa;
    color: #6c757d;
    font-size: 13px;
    transition: background-color 0.2s ease;
  }
  
  .language-settings:hover {
    background-color: #e9ecef;
  }
  
  .language-settings svg {
    margin-right: 8px;
  }
  
  .dropdown-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
  }
  
  .fade-enter, .fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }
  
  /* 响应式设计 */
  @media (max-width: 768px) {
    .current-language {
     // min-width: 120px;
      padding: 6px 10px;
    }
    
    .language-name {
      font-size: 0.8rem;
      text-wrap: nowrap;
    }
    
    .language-dropdown {
      position: fixed;
      top: auto;
      bottom: 0;
      left: 0;
      right: 0;
      border-radius: 12px 12px 0 0;
      max-height: 60vh;
      overflow-y: auto;
      margin-top: 0;
      transform: translateY(100%);
      animation: slideUp 0.3s ease forwards;
    }
    
    .dropdown-backdrop {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
  
  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
  
  /* 紧凑模式 */
  .language-selector.compact .current-language {
    padding: 4px 8px;
    min-width: auto;
  }
  
  .language-selector.compact .language-name {
    display: none;
  }
  
  .language-selector.compact .language-flag {
    margin-right: 0;
  }
  </style>